import React from "react";
import { Box, Typography, Container } from "@mui/material";
const TermsOfUse = () => {
  return (
    <Container
      maxwidth={false}
      sx={{
        maxwidth: "1300px",
        marginTop: { xs: "0px", sm: "80px", lg: "50px" },
        marginBottom: { xs: "5px", sm: "80px", lg: "0px" },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Ensure vertical stacking on smaller screens
          justifyContent: "center", // Center content vertically
          padding: { xs: "0px", sm: "20px" },
          marginBottom: { xs: "0px", md: "0px" },
        }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", textAlign: "center" }}>
          SAVA Terms Of Use
        </Typography>
        <Typography>
          Below are the SAVA-TECH Website’s terms and conditions that apply when
          you access and use the SAVA-TECH (“Site”). These Terms of Use apply
          between you and SAVA-TECH FINANCIAL SERVICES LIMITED (registration
          number 164481298) and any of its affiliated companies (“SAVA-TECH”,
          “we”, “our” or “us”) along with the other legal documents that govern
          the Site
        </Typography>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Important Information
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                Use of the Site: These Terms of Use apply to your use of the
                Site. This includes the Site itself and its content (including
                the text, images, and other information on the Site). By
                accessing the Site, you agree to be bound by the Terms of Use.
              </li>
              <li>
                Legal Agreement: You agree to be legally bound by the Terms of
                Use by visiting and using the Site. You may not use the Site and
                must immediately stop doing so if you do not agree to the Terms
                of Use.
              </li>
              <li>
                Product and Platform Terms: Separate terms apply to our products
                and services, and if you use our products or services, these
                will apply to you. We will make them available to you when you
                take up a product with us.
              </li>
              <li>
                Changes to the Terms of Use: We may change these terms at any
                time, but customers will be notified of any changes before they
                take effect. By continuing to access this Site after receiving
                notice, you accept such changes.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Use of and access to the Site
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                Information on the Site: The information held on this Site is
                for your personal, non-commercial use only. You may not
                transmit, modify, copy, or make commercial use of the Site or
                any part of it without our prior permission. The intention
                behind the Site is to give you information about SAVA-TECH.
              </li>
              <li>
                Non-commercial use: You may download and/or print out all or
                part of the Site for your own personal, non-commercial use. Any
                reproduction of the content on the Site must include the
                relevant copyright notice.
              </li>
              <li>
                Limited license to use the Site: We grant you a limited license
                to use the Site. We may cancel your license at any time for any
                reason. Your license is automatically cancelled if you do not
                get our written permission before using this Site in a way these
                Terms of Use do not allow.
              </li>
              <li>
                Availability of the Site: While we try to ensure that access to
                the Site is always available, we may change, suspend, or
                discontinue the Site or any part of it without notice. The Site
                or any part of it may not always be available.
              </li>
              <li>
                Taking away access: We may take away your rights to use the Site
                or its content for any reason, but you will be notified before
                such action is taken.
              </li>
              <li>
                Breach of Terms: If you breach the Terms of Use or infringe any
                other person’s rights (including copyright), we may cancel your
                license, block you from using the Site, claim specific
                performance or damages against you, and take any other steps the
                law allows, without affecting our rights.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Prohibited Use
          </Typography>
          <Typography variant="body1">
            <Typography variant="body">You are not allowed to:</Typography>

            <ul>
              <li>
                Introduce any materials that are designed to hamper the
                operations of the Site or its content.
              </li>
              <li>
                Damage, disable, overburden, impair, or gain unauthorized access
                to the content or the Site.
              </li>
              <li>
                Remove, modify, disable, block, obscure, or otherwise impair any
                advertising displayed on, or used in connection with, the Site.
              </li>
              <li>
                Use the Site or the content to advertise or promote products or
                services that we have not expressly approved in writing in
                advance.
              </li>
              <li>
                Interfere with anyone else’s use and enjoyment of the Site.
              </li>
              <li>
                Attempt to discover or reverse engineer the source code and
                other materials forming part of the technology used to provide
                the Site or forming part of the content.
              </li>
              <li>
                Receive or charge money, favors, or other consideration for
                allowing any other person to use or access the Site or the
                content.
              </li>
              <li>Do anything that violates any of these Terms of Use.</li>
              <li>
                Do anything which is illegal, fraudulent, or violates or
                infringes any rights, title, or interest (including any
                intellectual property rights) in or to this Site or its content.
              </li>
              <li>
                Deep link (link to any page other than the home page of this
                Site) or link in any way that could suggest that we endorse or
                support you or a third party, or that you have any rights in our
                Site or intellectual property, without our permission.
              </li>
              <li>
                Remove, disable, bypass, or circumvent any protection mechanisms
                or access control mechanisms on the Site.
              </li>
              <li>
                Use any technology (including spiders, crawlers, bots, and
                similar virtual agents) to search or gain any information from
                this Site, without our permission.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Sava Account
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                By making an application for credit or registering as an
                investor on the Exchange, you agree and confirm:
              </li>

              <li>
                All the information you have provided is accurate and correct
                and you are the person whose details you have provided.
              </li>
              <li>You can enter into a legally binding agreement with us.</li>
              <li>
                You will only use the Exchange for investing or borrowing
                purposes as envisaged by these Terms and the applicable Investor
                Terms or Loan Contract.
              </li>
              <li>
                You have provided a current address, telephone number, and
                e-mail address and will notify us immediately if your contact
                details change.
              </li>
              <li>
                In the case of an individual, you are 18 years of age or over
                and capable of taking responsibility for your own actions.
              </li>
              <li>
                In the case of a company, you are an officer of the company or
                you are otherwise authorized to act on behalf of the company.
              </li>
              <li>
                You authorize us, at any time, to use any means that we consider
                necessary to verify your identity with any third-party providers
                of information. Please refer to the Privacy Policy for details
                of steps we may undertake to do this.
              </li>
              <li>
                If an application for credit has been made by a third party on
                your behalf (for example, by a credit broker), you will be asked
                to confirm that the information entered by the third party is
                true and accurate before you enter into the Loan Contract. By
                doing so, you confirm the statements in the previous section are
                correct.
              </li>

              <li>
                When you register or apply for credit on the Exchange (or in the
                case of an application made by a third party, when you first
                access your account):
              </li>
              <li>
                You will be given a Sava account number and asked to set a
                password.
              </li>
              <li>
                You agree to keep your password and Sava account number strictly
                confidential and you must not disclose them to any third party.
                You agree to protect them in the same way as you would the
                details of your bank account or your bank cards. Any failure to
                do so shall be at your sole risk and expense.
              </li>
              <li>
                You should change your password on a regular basis. Passwords
                should contain a mixture of upper and lower-case letters and
                numbers and/or symbols. Passwords are case sensitive, and we
                recommend the use of passwords that combine a combination of
                numbers, symbols, and letters in different cases. This will help
                to prevent the risk of unauthorized use of your account.
              </li>
              <li>
                You agree that we are entitled to assume all correspondence,
                orders, transfers, and instructions made by reference to your
                password and account number are made by you.
              </li>
              <li>
                You agree to inform us immediately by e-mail and by telephone if
                you know or suspect that any of your account information or
                password is being misused so that we can take any actions
                necessary to protect your account, which may include suspending
                your account.
              </li>

              <li>
                We can close or suspend your Sava account (and stop providing
                any services) by giving you at least two months’ notice.
              </li>
              <li>
                We may end our agreement with you, stop providing any services,
                and close your Sava account immediately if we reasonably believe
                you have seriously or persistently broken any terms of the
                agreement (including these Terms, the Investor Terms, and the
                Loan Contracts) or we have reasonable grounds for thinking you
                have done any of the following things:
              </li>
              <li>
                You do not respond to our reasonable requests for information or
                you fail to provide such information.
              </li>
              <li>
                We suspect that you have committed or have been involved in
                fraud, money laundering, or other criminal activities.
              </li>
              <li>You inappropriately let someone else use your account.</li>
              <li>
                We discover that any information you have provided to us is
                materially incorrect, inaccurate, false, or misleading.
              </li>
              <li>
                You put us in a position where we might break a law, regulation,
                code, or other duty that applies to us if we maintain your
                account.
              </li>
              <li>
                You behave in a threatening or abusive manner to our staff.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Intellectual property rights
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                Ownership: Unless otherwise provided, we are the owner or
                licensee of all copyright, trademarks, and other intellectual
                property rights in and to the Site.
              </li>
              <li>
                Your rights: Your rights to use the Site and its content are
                limited to those that we give to you in the Terms of Use.
              </li>
              <li>
                No license for use: We do not grant you any license or right to
                use any of our trademarks or other intellectual property on this
                Site by virtue of your use of or access to the Site.
              </li>
              <li>
                Restrictions: Except as expressly permitted under the agreement,
                the website and its content may not be:
                <ul>
                  <li>Modified or used to make derivative works;</li>
                  <li>Rented, leased, loaned, sold, or assigned;</li>
                  <li>Reverse engineered or copied; or</li>
                  <li>Reproduced or distributed.</li>
                </ul>
              </li>
              <li>
                Proprietary notices: You may not remove any copyright,
                trademark, or other proprietary notices from the content.
              </li>
              <li>
                Requested cease of use: You must stop using our trademarks or
                other content immediately if we ask you to do so.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Data accuracy and errors
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                You agree to inform us as soon as possible if any information
                provided by you or contained in your Sava Account changes and/or
                if you become aware of any errors with respect to your Sava
                Account.
              </li>
              <li>
                The content on the Websites is provided for general information
                only and is not intended to amount to advice on which you should
                rely. Although we make reasonable efforts to update the
                information on the Websites, we make no promises that the
                content on the Websites is accurate, complete, or up to date.
              </li>
              <li>
                We reserve the right to remove from the Exchange any loan offers
                which are the subject of any error.
              </li>
            </ul>
          </Typography>
        </Box>

        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Data accuracy and errors
          </Typography>
          <Typography variant="body1">
            <ul>
              <li>
                You agree to inform us as soon as possible if any information
                provided by you or contained in your Sava Account changes and/or
                if you become aware of any errors with respect to your Sava
                Account.
              </li>
              <li>
                The content on the Websites is provided for general information
                only and is not intended to amount to advice on which you should
                rely. Although we make reasonable efforts to update the
                information on the Websites, we make no promises that the
                content on the Websites is accurate, complete, or up to date.
              </li>
              <li>
                We reserve the right to remove from the Exchange any loan offers
                which are the subject of any error.
              </li>
            </ul>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default TermsOfUse;
